//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DownChevron from '~/static/down-chevron.svg';
import UpChevron from '~/static/up-chevron.svg';
import { lightenColor } from '~/util/global';

export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
    isWishlist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showingDescription: false,
    };
  },
  computed: {
    up() { return UpChevron; },
    down() { return DownChevron; },
    background() {
      if (this.collection.header_background) {
        const dk = this.collection.header_background.replace('#', '');
        const lt = lightenColor(dk, 25);
        return `radial-gradient(58.66% 71.5% at 64.93% 27.87%, #${lt} 24.72%, #${dk} 100%)`;
      }

      return null;
    },
  },
  methods: {
    toggleDescription() {
      this.showingDescription = !this.showingDescription;
    },
  },
};
